'use strict';

angular.module('cgmemApp')
	.controller('SelectCtrl', function ($scope, $state, $log, WorkingAccount, Transaction, AppConfig) {

		AppConfig.get()
			.then(function (appConfig) {
				WorkingAccount.get()
					.then(function (workingAggregate) {
						Transaction.initialize()
							.then(function () {

								$scope.alert = "";
								$scope.findTrans = Transaction.findTrans;
								$scope.inCart = Transaction.inCart;
								$scope.groupInCart = Transaction.groupInCart;
								var productsShown = false;

								$scope.toggleMemberProduct = function (p, m) {
									if (Transaction.inCart(p, m))
										Transaction.removeFromCart(p, m);
									else {																// adding
										if ($scope.group.singleSelect) {			// should only have 1 product from current group
											Transaction.removeGroup($scope.group);		// delete the whole group
										}
										Transaction.addProductToCart(p, m);	// then add
									}
									$scope.cart = Transaction.getCart();
								}

								$scope.group = null;
								$scope.fpl = [];

								var i = -1;	// current group index

								$scope.currentPrice = Transaction.currentPrice;
								var pg = _(appConfig.productGroups)
									.filter({ containsProductType: 'membership' })
									.sortBy(['groupId'])
									.value();
								$scope.next = function () {
									// go to the next (or on initialization, FIRST) group with valid stuff to show
									while (++i < pg.length) {
										var fpl = Transaction.availableProducts(workingAggregate.members, pg[i]);
										if (fpl.length) {
											$scope.fpl = fpl;
											$scope.discounts = Transaction.availableDiscounts(fpl);
											$scope.group = pg[i];
											productsShown = true;
											break;
										}
									}

									if (i >= pg.length) {		// we have reached the end
										// add the automatic products
										if (!productsShown)
											return $state.go("^.noproducts");
										Transaction.addExtras();
										$state.go("^.policies")
									}
								}
								$scope.next();		// Get started
							});
					});
			});
	})
	.controller('PoliciesCtrl', function ($scope, $state, Transaction) {
		if (!Transaction.ready())
			return $state.go('authenticated.profile');

		$scope.policies = Transaction.applicablePolicies();
		if (!$scope.policies || !$scope.policies.length) $state.go("^.extras");

	})
	.controller('ExtrasCtrl', function ($scope, $state, Transaction) {
		if (!Transaction.ready())
			return $state.go('authenticated.profile');

		$scope.needyTransactions = _(Transaction.getCart())
			.filter('product.extraRequired')
			.value();

		_.forEach($scope.needyTransactions, function (t) {
			t.extra = {};
			t.extra.option = t.product.extraRequired.optionList[0];
		});

		if (!$scope.needyTransactions || !$scope.needyTransactions.length)
			$state.go("^.confirm");
	})
	.controller('ConfirmCtrl', function ($scope, $state, $http, $log, Transaction, WorkingAccount) {
		//$log.info('Confirm controller started');
		$scope.valid = true;
		if (!Transaction.ready())
			return $state.go('authenticated.profile');


		WorkingAccount.get()
			.then(function (workingAggregate) {
				$scope.cart = Transaction.getCart();
				$scope.accountBalance = workingAggregate.account.balance;
				$scope.total = Transaction.getTotal() + workingAggregate.account.balance;
				$scope.valid = $scope.cart.length || $scope.accountBalance > 0;
			});

		$scope.confirm = function () {
			return $state.go("^.pay");
		}
	})
	.controller('PayCtrl', function ($scope, $rootScope, $state, $q, $log, BrainTree, Transaction, WorkingAccount, Logger, User) {

		$scope.loading = true;

		// addon for Braintree submit function
		$scope.submit = function () {
			$scope.loading = true;
		}

		var persistTransactions = function (p) {
			$scope.loading = true;
			Transaction.save(p)
				.then(function (data) {
					//$scope.loading = false;
					if (data)
						return $state.go("^.receipt", data);
					else
						return $state.go("authenticated.profile");
				}, function (err) {
					$log.warn("transaction save failed:", err)
					$rootScope.$emit('generalAlert', err);
					$scope.loading = false;
				});
		}

		$scope.checkPay = function () {
			persistTransactions();
		}

		var promises = [WorkingAccount.get()];
		if (!Transaction.ready())
			promises.push(Transaction.initialize());

		$q.all(promises)
			.then(function (d) {
				var workingAggregate = d[0];

				$scope.cardholderName = "";
				$scope.cart = Transaction.getCart();
				$scope.accountBalance = workingAggregate.account.balance;
				$scope.allowCheckPayments = User.isInGroup("admins") || workingAggregate.account.allowCheckPayments;
				$scope.total = Transaction.getTotal() + workingAggregate.account.balance;

				if ($scope.total <= 0) {
					if ($scope.cart.length)
						return persistTransactions();
					else
						return $state.go("authenticated.profile");
				}

				var hostedFieldsConfig = {
					styles: {
						".valid": {
							"color": "green"
						},
						".invalid": {
							"color": "red"
						}
					},
					fields: {
						number: {
							selector: "#card-number"
						},
						cvv: {
							selector: "#cvv"
						},
						expirationMonth: {
							selector: "#exp-month",
							placeholder: "MM"
						},
						expirationYear: {
							selector: "#exp-year",
							placeholder: "YYYY"
						}
					}
				};

				var onError = function (err) {
					if (err.type == 'CUSTOMER')
						Logger.log("Braintree onError:", err);
					else
						Logger.log("*** ATTENTION REQUIRED: Braintree onError:", err);

					$rootScope.$emit('generalAlert',
						err.type == 'CUSTOMER' ?
							"ERROR: please check the fields highlighted in RED" :
							"ERROR: There was a system problem processing this transaction.  Please try again or contact CG at info@countryglen.org"
					);
					$scope.loading = false;
				}

				var onPaymentMethodReceived = function (o) {
					//$log.log("Payment Method Received");
					// we are already loading, no need to set the flag
					var p = new Transaction.transaction(null, null, 'ccpayment', -$scope.total, { cardholderName: $scope.cardholderName, nonce: o.nonce });
					persistTransactions(p);
				}

				BrainTree
					.init("#cc-form", hostedFieldsConfig, onError, onPaymentMethodReceived)
					.then(function () {
						$scope.loading = false;
					})
					.catch(function (err) {
						$scope.loading = false;
						$rootScope.$emit('generalAlert', "Error communicating with the Payment Gateway. Please try again later.");
						$log.error('Error communicating with the payment gateway', err);
					});
				$scope.$on("$destroy", function () {
					BrainTree.teardown();
				});
			})
	})
	.controller('ReceiptCtrl', function ($scope, $state, $stateParams, Transaction) {
		if (!Transaction.ready() || !$stateParams.transactions || !$stateParams.transactions.length)
			return $state.go('authenticated.profile');
		$scope.balanceForward = $stateParams.balanceForward;
		$scope.transactions = $stateParams.transactions;
		$scope.balance = $stateParams.closingBalance;

		$scope.ccpayment = _.find($stateParams.transactions, { type: 'ccpayment' });
		$scope.accountNumber = $stateParams.transactions[0].account.accountNumber;				//FIX

		$scope.print = function ($event) {
			$event.target.blur();
			window.print();
		}
	})
	.controller('ReserveCtrl', function ($rootScope, $scope, $state, $uibModal, $http, $q, $log, AppConfig, WorkingAccount, Transaction, User) {
		var user = {};
		var availableProducts = [];

		$scope.loading = true;
		$scope.instructionsRead = false;

		$q.all([AppConfig.get(), WorkingAccount.get(), Transaction.initialize(), User.get()])
			.then(function (r) {
				$scope.loading = false;
				$scope.appConfig = r[0];
				user = r[3];

				var partyProductGroups = _($scope.appConfig.productGroups || [])
					.filter({ containsProductType: 'party' })
					.map('groupId').value();

				availableProducts = _.filter($scope.appConfig.products, function (p) {
					return partyProductGroups.indexOf(p.groupId) >= 0;
				})
				$scope.durations = _(availableProducts).map('duration').uniq().value();

				if (!r[1].account.sMS || !r[1].account.sMS[r[0].season]) {
					$uibModal.open({
						templateUrl: 'notMember.html',
					}).result.then(function () {
						$state.go('authenticated.profile');
					});
				} else if (!availableProducts.length) {
					$uibModal.open({
						templateUrl: 'noPartyProduct.html',
					}).result.then(function () {
						$state.go('authenticated.profile');
					});
				}
			})
			.catch(function (err) {
				$log.error(err);
			});

		$scope.dt = '';
		$scope.startTime = moment().startOf('day').add('9', 'hours').toDate();

		var now = new Date();
		$scope.pcTZOffset = now.getTimezoneOffset() - moment.tz.zone('America/New_York').utcOffset(now);
		$scope.pcTZ = moment.tz.guess();

		$scope.reservation = {
			duration: 2,
			under10s: 0,
			totalPeople: 10,
			additionalInfo: ""
		};

		$scope.$watch('dt', function () {
			if ($scope.dt) {
				$scope.loading = true;
				$http.get('/api/reservations', { params: { date: $scope.dt.toISOString().substring(0, 10) } })
					.then(function (d) {
						$scope.availability = d.data.slots && d.data.slots.length ? d.data.slots[0] : null;
						$scope.existingReservations = d.data.bookings;
						$scope.loading = false;
						$scope.startTime = $scope.availability && new Date($scope.availability.start);
					})
					.catch(function (err) {
						$rootScope.$emit('generalAlert', 'Error retrieving calendar data: ' + err.data);
						$scope.loading = false;
					})
			} else {
				$scope.availability = null;
				$scope.existingReservations = null;
			}
		});

		$scope.$watchGroup(['startTime', 'reservation.duration'], function () {
			$scope.startTimeValid = true;
			if (!$scope.availability) {
				$scope.startTimeValid = false;
				return;
			}
			var s = moment($scope.startTime);
			var e = moment($scope.startTime).add($scope.reservation.duration, 'hours');
			if (s.isBefore($scope.availability.start) || e.isAfter($scope.availability.end)) {
				$scope.startTimeValid = false;
			}
			_.forEach($scope.existingReservations, function (r) {
				if (!(e.isSameOrBefore(r.start) || s.isSameOrAfter(r.end))) {
					$scope.startTimeValid = false;
				}
			});
		})

		$scope.localTimeStr = function (t) {
			return moment.tz(t, 'America/New_York').format("h:mm a");
		}

		$scope.options = {
			minDate: moment().add('3', 'd').valueOf(),
			maxDate: moment().add('180', 'd').valueOf(),
			//minDate: new Date(),
			showWeeks: false
		};


		$scope.book = function () {

			var p = _.find(availableProducts, function (p) {
				return $scope.reservation.under10s <= p.maxUnder10s
					&& $scope.reservation.duration == p.duration
					&& typeof Transaction.currentPrice(p) === 'number'
			});
			if (!p) {
				$uibModal.open({
					templateUrl: 'noMatchingPartyProduct.html',
				}).result.then(function () {
					return;
				});
			}

			// Combine the date and time
			$scope.dt.setHours($scope.startTime.getHours());
			$scope.dt.setMinutes($scope.startTime.getMinutes());
			$scope.dt.setSeconds(0);
			$scope.reservation.start = $scope.dt;

			/*moment.tz($scope.dt.toISOString().substring(0, 10) + 'T'
														+ moment($scope.startTime).format('HH:mm:ss'),
														'America/New_York');
			*/
			Transaction.addProductToCart(p, null, $scope.reservation);	// then add
			$state.go('authenticated.shop.confirm');
		}
	})
	.controller('PassesCtrl', function ($scope, $q, $state, $log, WorkingAccount, Transaction, AppConfig) {
		$scope.loading = true;
		$scope.qty = 1;

		$q.all([AppConfig.get(), Transaction.initialize()])
			.then(r => {
				let passGroups = r[0].productGroups
					.filter(e => e.containsProductType === 'pass');

				$scope.passes = passGroups
					.reduce((acc, g) => acc.concat(Transaction.availableProducts(null, g)),[])
					.map(e => (
						{
							product: e,
							currentPrice: Transaction.currentPrice(e),
							qty: 0
						}
					));
				$scope.loading = false;
			});

		$scope.cancel = () => $state.go('authenticated.profile');

		$scope.purchase = () => {
			$scope.passes.forEach(p => {
				if (p.qty) {
					let t = new Transaction.transaction(
						p.product,
						null,
						'purchase',
						p.currentPrice * p.qty,
						null, null,
						p.qty
					);
					Transaction.addTransactionToCart(t);
				}
			});
			$state.go('authenticated.shop.policies');
		}
	});